import {observable} from "mobx";

export default class UnloadStore {
    id?: string;
    storeId: string;
    @observable isActive: boolean;
    @observable hasChanges: boolean = false;

    constructor(storeId: string, isActive: boolean, id?: string) {
        this.id = id;
        this.storeId = storeId;
        this.isActive = isActive;
    }

    changeActive(value: boolean) {
        this.isActive = value;
        this.hasChanges = true;
    }
}
